import './protected-layout.less'

import React, {Component} from 'react';
import Header from './header';
import classNames from 'classnames';
import {inject, observer} from 'mobx-react';

@inject("crmStore")
@observer
export default class ProtectedLayout extends Component {
  componentDidMount() {
    this.props.crmStore.load();
  }

  render() {
    return (
      <div className={classNames('playout', this.props.className)}>
        <Header
          crmCountUnread={this.props.crmStore.totalUnreadAll}
          tools={this.props.right}
          title={this.props.headerTitle}
          onLogout={this.props.onLogout}
        />
        <div className="content">
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/protected-layout.js